const KEY = 'recent_listings';
const MAX = 10;

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
};

export const rememberListing = (listing, path) => {
  if (!listing?.id) return;
  const entry = {
    id: listing.id,
    title: listing.title,
    price: listing.price,
    price_type: listing.price_type,
    image: listing.images?.[0] || null,
    path: path || `/listing/${listing.id}`,
    viewed_at: Date.now(),
  };
  const rest = getRecentlyViewed().filter((l) => l.id !== listing.id);
  localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, MAX)));
};

export const clearRecentlyViewed = () => localStorage.removeItem(KEY);
